import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getPageSettings } from "../services/pagesettingServices.ts";

const ensureMeta = (name, attr = "name") => {
  let tag = document.querySelector(`meta[${attr}="${name}"]`);

  // 1. Define the reference point (the very start of the <head>)
  const firstHeadChild = document.head.firstChild;

  if (!tag) {
    // 2a. Tag does NOT exist: Create it and insert it at the beginning.
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    tag.setAttribute("data-meta-key", name); // Optional: A custom attribute for easier debugging/identification

    document.head.insertBefore(tag, firstHeadChild);
  } else {
    // 2b. Tag DOES exist: Move the existing tag to the beginning.
    // insertBefore(elementToMove, referenceElement)
    // If elementToMove is already in the DOM, insertBefore will move it.

    // We only need to move it if it's not already the first child
    if (tag !== firstHeadChild) {
      document.head.insertBefore(tag, firstHeadChild);
    }
  }

  return tag;
};

export default function usePageMeta(pageKey) {
  const { language } = useLanguage();

  useEffect(() => {
    let active = true;
    const apply = async () => {
      try {
        const pageMap = {
          "homepage": "seo-home",
          "contact_us": "seo-contactus",
          "vehicles": "seo-vehicle",
          "blog": "seo-blog",
          "auctions": "seo-auction",
          "seller": "seo-sellerpage",
          "buyer": "seo-buyerpage",
          "about_us": "seo-about"
        };
        const mappedPage = pageMap[pageKey] || `seo-${pageKey}`;

        const data = await getPageSettings({
          page: mappedPage,
          lang: language,
        });

        //const metaList = data?.seo || [];
        const seoKey = Object.keys(data || {})[0];
        const metaList = data?.[seoKey] || [];
        const meta = Array.isArray(metaList) ? metaList[0] : metaList;
        const title = meta?.meta_title?.value || "Sky Auto Trade Auction - Car Auctions";
        const description = meta?.meta_description?.value || "";
        const keywords = meta?.meta_keywords?.value || "";

        if (!active) return;
        document.title = title;
        ensureMeta("keywords").setAttribute("content", keywords);
        ensureMeta("description").setAttribute("content", description);
        ensureMeta("title").setAttribute("content", title);
      } catch (e) {
        // silent fail
      }
    };
    apply();
    return () => {
      active = false;
    };
  }, [pageKey, language]);
}
